import axios from 'axios';
import {
  loginRequest,
  loginSuccess,
  loginFailure,
  logoutUserRequest,
  logoutUserSuccess,
  logoutUserFailure,
  registerRequest,
  registerSuccess,
  registerFailure,
} from '../Reducer/userReducer';

export const loginUser = (email, otp) => {
  return async (dispatch) => {
  console.log('Login action called with email:', email, 'and OTP:', otp); // Debugging log
    try {
      dispatch(loginRequest());

      const response = await axios.post(
        '/api/login',
        { email, otp },
        { withCredentials: true }
      );

      const user = response.data.user;
      localStorage.setItem('user', JSON.stringify(user));
      dispatch(loginSuccess(user));

      return Promise.resolve({ success: true, user }); // ✅ return Promise
    } catch (err) {
      const errorMessage = err?.response?.data?.message || 'Login failed. Please check your credentials.';
      dispatch(loginFailure(errorMessage));
      return Promise.reject({ success: false, message: errorMessage }); // ✅ reject on error
    }
  };
};



export const logoutUser = () => (dispatch) => {
  dispatch(logoutUserRequest());
  try {
    localStorage.removeItem('user'); // Clear localStorage on logout
    dispatch(logoutUserSuccess());
  } catch (err) {
    dispatch(logoutUserFailure('Logout failed.'));
  }
};


// New registration action
export const registerUser = (username,email, password,confirmPassword) => async (dispatch) => {
  try {
    dispatch(registerRequest());

    const response = await axios.post(
      '/api/register',
      { username,email, password,confirmPassword },
      { withCredentials: true }
    );

    dispatch(registerSuccess(response.data.user));
  } catch (err) {
    console.error('Registration error:', err);
    dispatch(registerFailure('Registration failed. Please try again.'));
  }
};
